import React, { useState } from 'react';
import { FaDesktop, FaMobileAlt, FaUserLock } from 'react-icons/fa';

const UserPrevelies = () => {
    const [activeTab1, setActiveTab1] = useState('web');

    const tabs = [
        { id: 'web', label: 'Web App', icon: <FaDesktop /> },
        { id: 'mobile', label: 'Mobile App', icon: <FaMobileAlt />, disabled: true },
    ];

    const content1 = {
        web: '',
        mobile:
            '',
    };

    const content2 = {
        web: '',
        mobile:
            '',
    };

    const content3 = {
        web: '',
        mobile:
            '',
    };
    const content4 = {
        web: '',
        mobile:
            '',
    };
    const content5 = {
        web: '',
        mobile:
            '',
    };
    const content6 = {
        web: '',
        mobile:
            '',
    };




    const renderTabs = (activeState, setActiveState) => (
        <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    onClick={() => !tab.disabled && setActiveState(tab.id)}
                    className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
                        ? 'bg-[#1a9588] text-white shadow-md'
                        : 'bg-[#dbf4f1] text-gray-600 hover:bg-[#b9ece6] bg-gray-700 hover:bg-gray-600'
                        } ${tab.disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                    disabled={tab.disabled}
                >
                    {tab.icon}
                    {tab.label}
                </button>
            ))}
        </div>
    );

    return (
        <div>
            <div className="text-start">

                <div className="flex items-center gap-4 mb-8">
                    <FaUserLock className="text-pink-600 text-5xl" />
                    <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">User Privileges</h1>
                </div>
            </div>
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 sm:mb-8 gap-4">
                <div className="flex flex-wrap gap-2">
                    <span className="bg-pink-600 text-white px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
                        Seller
                    </span>
                    <span className="bg-yellow-100 text-yellow-600 px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
                        Buyer
                    </span>
                </div>
                <div className="flex flex-wrap gap-2">
                    <span className="bg-blue-100 text-blue-600 px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
                        Web
                    </span>
          
                    <span className="bg-green-100 text-green-600 px-3 py-1 rounded-lg font-semibold text-xs md:text-sm sm:text-sm">
                        Android
                    </span>
                </div>
            </div>

            <div className=" bg-white p-6 rounded shadow text-start">

                {/* Intro */}
                <p className="text-gray-700 mb-6">
                    Every user in Selzor has a set of privileges, that can be set by going to the 'User' section.
                </p>

                {/* Adding / Updating Users */}
                <h2 className="text-lg font-semibold mb-2">Adding / Updating Users</h2>
                <p className="text-gray-700 mb-4">
                    All connections in Selzor work on an invitation basis. Before adding a user, ensure they have registered on Selzor. If they haven’t, ask them to sign up and verify the mobile number or email address used during registration. Only after that can you send them an invitation to join your ‘Seller’ or ‘Buyer’ account.
                </p>

                {/* Steps */}
                <p className="text-gray-700 mb-2">Steps to add a user are as follows</p>
                <ul className="border border-gray-200 rounded divide-y divide-gray-200 mb-4">
                    <li className="p-2">Find a registered Selzor user using their mobile number or email address.</li>
                    <li className="p-2">Select User Type & Set Privileges</li>
                    <li className="p-2">Send Request</li>
                </ul>

                {/* Final Note */}
                <p className="text-gray-700">
                    After the invited user accepts your ‘User’ request, they will be added to your ‘Seller’ or ‘Buyer’ account and will be able to perform all actions based on the privileges assigned during setup.
                </p>

            </div>

            <div className='my-5'>
                {renderTabs(activeTab1, setActiveTab1)}
                <div className="rounded-lg p-2 sm:p-4 flex justify-start">
                    <img
                        src={content1[activeTab1]}
                        alt={`${activeTab1} view`}
                        className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
                    />
                </div>
            </div>


            <div className='my-5'>

                <div className="text-start">
                    <h3 className="text-2xl text-gray-500 mb-2">Seller User - Admin</h3>
                </div>


                {renderTabs(activeTab1, setActiveTab1)}
                <div className="rounded-lg p-2 sm:p-4 flex justify-start">
                    <img
                        src={content2[activeTab1]}
                        alt={`${activeTab1} view`}
                        className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
                    />
                </div>
            </div>

            <div className='my-5'>

                <div className="text-start">
                    <h3 className="text-2xl text-gray-500 mb-2">Seller User - Manager</h3>
                </div>


                {renderTabs(activeTab1, setActiveTab1)}
                <div className="rounded-lg p-2 sm:p-4 flex justify-start">
                    <img
                        src={content3[activeTab1]}
                        alt={`${activeTab1} view`}
                        className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
                    />
                </div>
            </div>

            <div className='my-5'>

                <div className="text-start">
                    <h3 className="text-2xl text-gray-500 mb-2">Seller User - Sales Rep</h3>
                </div>

                {renderTabs(activeTab1, setActiveTab1)}
                <div className="rounded-lg p-2 sm:p-4 flex justify-start">
                    <img
                        src={content4[activeTab1]}
                        alt={`${activeTab1} view`}
                        className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
                    />
                </div>
            </div>


            <div className='my-5'>

                <div className="text-start">
                    <h3 className="text-2xl text-gray-500 ">Seller User - Distributor</h3>
                    <p className="text-gray-600 my-3">
                        Detailed information about 'Distributor' is available in the Distributor section.
                    </p>
                    <h3 className="text-2xl text-gray-500 mb-2">Buyer User</h3>
                </div>

                {renderTabs(activeTab1, setActiveTab1)}
                <div className="rounded-lg p-2 sm:p-4 flex justify-start">
                    <img
                        src={content5[activeTab1]}
                        alt={`${activeTab1} view`}
                        className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
                    />
                </div>
            </div>

            <div className='my-5'>

                <div className="text-start">
                    <h3 className="text-2xl text-gray-500 mb-2">User Request</h3>
                    <p className="text-gray-600 my-3">
                        The user to whom the request is sent, see the following dialog when he logs in to his Selzor account the next time.
                    </p>
                </div>

                {renderTabs(activeTab1, setActiveTab1)}
                <div className="rounded-lg p-2 sm:p-4 flex justify-start">
                    <img
                        src={content6[activeTab1]}
                        alt={`${activeTab1} view`}
                        className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
                    />
                </div>
            </div>






        </div>
    );
};

export default UserPrevelies;